/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";

import { Card, Checkbox } from "@veneer/core";
import { useCallback } from "react";
import GridColumn from "../GridColumn";

import { tokens } from "../../css.settings";

const cardStyle = css`
  border-color: #cecece;
  border-radius: 8px;
`;

const contentStyle = css`
  padding: ${tokens.layout.size5};
  position: relative;
  cursor: pointer;
`;

const checkboxStyles = css`
  width: 16px;
  height: 16px;
  > span.vn-checkbox__span {
    width: 16px;
    height: 16px;
    > svg.vn-checkbox__span--icon {
      width: 15px;
      height: 15px;
    }
  }
`;

const checkboxContainerStyle = css`
  position: absolute;
  top: 5px;
  left: 5px;
`;

const GridListColumn = ({
  id,
  content,
  selectable = false,
  selected = false,
  onToggleSelection,
  onClick,
  customStyle,
  ...rest
}) => {
  const handleSelectionClick = useCallback(() => {
    if (!selectable) {
      if (onClick) onClick({ id });
    } else {
      onToggleSelection(id);
    }
  }, [id, selectable, onClick, onToggleSelection]);

  return (
    <div style={customStyle}>
      <GridColumn
        {...rest}
        style={customStyle}
        data-testid={rest["data-testid"] || "grid-list-column"}
      >
        <Card
          css={cardStyle}
          content={
            <div
              css={contentStyle}
              onClick={handleSelectionClick}
              data-testid="grid-list-column-content"
            >
              {selectable && (
                <div css={checkboxContainerStyle}>
                  <Checkbox
                    css={checkboxStyles}
                    checked={selected}
                    data-testid="grid-list-column-checkbox"
                  />
                </div>
              )}
              <div>{content}</div>
            </div>
          }
        />
      </GridColumn>
    </div>
  );
};

export default GridListColumn;
